module.exports = __webpack_public_path__ + "assets/img/logo2.010b62d5.png";